import { __values } from "tslib";
import uuidv4 from 'uuid/v4';
import { logTaggedMessage } from '../reporter';
import React from 'react';
import ReactDOM from 'react-dom';
import { ChallengeModal } from './ChallengeModal';
var log = logTaggedMessage({ module: '3ds' });
function getChallengeIframeContainerElement() {
    return document.getElementById('3ds-challenge');
}
function getChallengeIframeElement(iframeName) {
    return document.getElementById(iframeName);
}
export var createVisibleIframe = function (cancelByUserDeferred) {
    if (getChallengeIframeContainerElement()) {
        log("WARNING! 3ds: createVisibleIframe: callenge modal iframe already exists");
        removeChallengeIframe();
    }
    var iframeName = "3ds-iframe-".concat(uuidv4());
    var el = document.createElement('div');
    el.id = '3ds-challenge';
    var onClose = function () {
        log("3ds: user closed challenge modal (cancelByUserDeferred.reject('CANCELLED_BY_USER'))");
        return cancelByUserDeferred.reject('CANCELLED_BY_USER');
    };
    ReactDOM.render(React.createElement(ChallengeModal, {
        onClose: onClose,
        iframeName: iframeName,
    }), el);
    document.body.appendChild(el);
    return iframeName;
};
export var removeChallengeIframe = function () {
    var el = getChallengeIframeContainerElement();
    if (!el) {
        log("WARNING! 3ds: removeChallengeIframe: callenge modal iframe not found on document");
        return;
    }
    log("3ds: removeChallengeIframe");
    document.body.removeChild(el);
};
export var createHiddenIframe = function () {
    var iframe = document.createElement('iframe');
    var iframeName = "3ds-iframe-".concat(uuidv4());
    iframe.name = iframeName;
    iframe.width = '0';
    iframe.height = '0';
    iframe.style.display = 'none';
    iframe.onload = function () { return log('3ds: hidden iframe loaded', { iframeName: iframeName }); };
    document.body.appendChild(iframe);
    return iframeName;
};
export var updateIframeSourceUsingGetRequest = function (_a) {
    var url = _a.url, iframeName = _a.iframeName;
    getChallengeIframeElement(iframeName).src = url;
};
export var postToIframe = function (_a) {
    var e_1, _b;
    var url = _a.url, fields = _a.fields, iframeName = _a.iframeName;
    var form = document.createElement('form');
    form.style.display = 'none';
    form.method = 'POST';
    form.target = iframeName;
    form.action = url;
    try {
        for (var _c = __values(Object.keys(fields)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var fieldName = _d.value;
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = fieldName;
            input.value = fields[fieldName];
            form.appendChild(input);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    document.body.appendChild(form);
    log("3ds: Posting hidden form into iframe", {
        url: url,
        fields: fields,
        iframeName: iframeName,
    });
    setTimeout(function () {
        try {
            if (document.body.contains(form)) {
                document.body.removeChild(form);
            }
        }
        catch (_a) { }
    }, 1000);
    form.submit();
};
//# sourceMappingURL=iframe-handler.js.map